<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="2001002">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleBIReportBO.ajax?cmd=getVehivleFeePage"
          :params="fullSearchData"
          bizName="车辆费用列表导出"
          bizCode="exp100074"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'customerCode'"
          ></el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {
  getVehivleFeePage,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'orgname', label: '部门' },
          { prop: 'sourcename', label: '线路' },
          { prop: 'platenumber', label: '车牌号' },
          { prop: 'datamonth', label: '月份' },
          { prop: 'totalfee', label: '费用合计' },
          { prop: 'cardepreciatefee', label: '车辆折旧费' },
          { prop: 'carrentfee', label: '车辆租金' },
          { prop: 'repairfee', label: '维修费' },
          { prop: 'maintainfee', label: '保养' },
          { prop: 'tyrefee', label: '轮胎费' },
          { prop: 'inspectfee', label: '年审' },
          { prop: 'insurancefee', label: '保险' },
          { prop: 'violationfee', label: '违章' },
          { prop: 'accidentfee', label: '事故' },
          { prop: 'parkingrate', label: '停车费' },
          { prop: 'gpsfee', label: 'GPS' },
          { prop: 'urea', label: '尿素' },
          { prop: 'extrasfee', label: '杂费' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getVehivleFeePage,
  },
};
</script>

<style lang="scss" scoped>
</style>
